<template>
  <div>
    <spinner-loader :loading="loading" />
    <div v-if="!loading">
      <section
        class="page-title"
        style=""
      >
        <div class="auto-container">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8 col-md-10 col-sm-12">
                <div class="card profile-card">
                  <div class="card-header d-block text-center">
                    <b-avatar
                      :src="organizerImage"
                      alt="organizer picture"
                      size="250"
                      class="mb-2"
                    />
                  </div>
                  <div class="card-body">
                    <section class="fun-fact-section Counter">
                      <div class="container">
                        <div class="fact-counter">
                          <ul class="counter-list d-flex align-items-center justify-content-center button-list-management-page clearfix">
                            <!--Column-->
                            <li class="counter-column my-0 wow fadeInUp">
                              <div class="count-box text-center">
                                <span
                                  class="count-text"
                                  data-speed="3000"
                                  data-stop="50"
                                >{{ organizer.no_of_follows }}</span>
                                <h4 class="counter-title">
                                  followers
                                </h4>
                              </div>
                            </li>
                            <!--Column-->
                            <li
                              class="counter-column my-0 wow fadeInUp"
                              data-wow-delay="400ms"
                            >
                              <div class="count-box text-center">
                                <span
                                  class="count-text"
                                  data-speed="3000"
                                  data-stop="1450"
                                >{{ organizer.events }}</span>
                                <h4 class="counter-title">
                                  events
                                </h4>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </section>
                    <ul class="social-link-profile d-flex flex-wrap align-items-center justify-content-center">
                      <li v-if="organizer.facebook"><a :href="organizer.facebook"><img
                        src="@/assets/images/icons/facebook.svg"
                        alt="icon"
                      ></a></li>
                      <li
                        v-if="organizer.instgram"
                        class="text-primary mr-1"
                      ><a :href="organizer.instgram">
                        <feather-icon
                          icon="InstagramIcon"
                          size="20"
                        />
                      </a></li>
                      <li v-if="organizer.twitter"><a :href="organizer.twitter"><img
                        src="@/assets/images/icons/logo-twitter.svg"
                        alt="icon"
                      ></a></li>
                    </ul>
                    <p v-html="organizer.bio" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <b-container class="p-md-5">
        <b-card class="shadow-none p-md-3">
          <b-tabs>
            <b-tab title="Events">
              <custom-tabs
                class="mt-3"
                :selected-tab.sync="tabIndex"
                :tabs="[{name:'upcoming',permission:true},{name:'past',permission:true}]"
              />
              <div v-show="tabIndex===0">
                <template v-if="organizer.upcomingEvents.length">
                  <div
                    v-for="event in organizer.upcomingEvents"
                    :key="event.id"
                  >
                    <event-preview :event="event" />
                  </div>
                </template>
                <span v-else>There are no upcoming events</span>
              </div>
              <div v-show="tabIndex===1">
                <template v-if="organizer.pastEvents.length">
                  <div
                    v-for="event in organizer.pastEvents"
                    :key="event.id"
                  >
                    <event-preview :event="event" />
                  </div>
                </template>
                <span v-else>There are no past events</span>
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>
import CustomTabs from '@/components/common/CustomTabs.vue'
import EventPreview from '@/components/Events/EventPreview.vue'
import Organizers from '@/compositions/Organizers/OrganizersAPI'
import SpinnerLoader from '@/components/Table/SpinnerLoader.vue'

export default {
  name: 'OrganizerView',
  components: { CustomTabs, EventPreview, SpinnerLoader },
  data() {
    return {
      tabIndex: 0,
      loading: false,
    }
  },
  computed: {
    organizerImage() {
      return this.organizer.image?.url
    },
  },
  setup() {
    const { organizer, showRequest } = Organizers()
    return { organizer, showRequest }
  },
  created() {
    this.getOrganizer()
  },
  methods: {
    getOrganizer() {
      this.loading = true
      this.showRequest(this.$route.params.id, { embed: 'image,pastEvents.mainImage,upcomingEvents,events.mainImage' }).then(res => {
        this.organizer = res.data.data
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss">
.page-title {
  position: relative;
  text-align: center;
  z-index: 1;
  padding: 80px 0 0px 0;
  background-repeat: no-repeat;
  background-position: top center;
  background-image:url('~@/assets/images/organization/organizer-banner.svg');
  background-size: 100%;
  min-height: 341px;
}
.card.profile-card
{
  padding: 30px 32px;
  box-shadow: unset;
  border-radius: 20px;
  border: 1px solid #fff;
}
.card.profile-card .card-header{
  padding: 0;
}
.card.profile-card .card-header img
{
  display: block;
  margin: 0 auto 40px auto;
  width: 168px;
  height: 168px;
  border-radius: 100%;
  object-fit: cover;
}
.card.profile-card .card-header p
{
  font-size: 1.5rem;
  line-height: 2rem;
  text-transform: capitalize;
  font-family: 'Nunito-Bold';
  margin-bottom: 30px;
  color: #313131;
}
.card.profile-card .card-body .counter-list
{
  margin-bottom: 20px !important;
}
.card.profile-card .card-body .counter-list li
{
  min-width: 140px;
}
ul.social-link-profile
{
  margin-bottom: 30px;
}
ul.social-link-profile li
{
  width: 56px;
  height: 56px;
  background: rgba(0, 128, 135, 0.06);
  border-radius: 100%;
  line-height: 56px;
  text-align: center;
}
ul.social-link-profile li:first-child
{
  margin-right: 20px;
}
.card.profile-card .card-body  p
{
  font-size: 1rem;
  color:  #313131;
  line-height: 1.375rem;
  text-align: center;
  margin-bottom: 30px;
  font-family: 'Nunito-Regular';
}
.taps-events-organization.profile-page
{
  padding: 117px 100px 40px 100px;
  border-radius: 25px;
  background: #fff;
  border: 1px solid #fff;
  margin-bottom: 40px;
}
.events-profile-content p
{
  text-transform: capitalize;
  color: #313131;
  font-size: 1.5rem;
  line-height: 2rem;
  margin-bottom: 24px;
  font-family: 'Nunito-Bold';
}
.events-profile-content .nav-tabs .nav-link
{
  min-width: auto;
}
p.no-data
{
  font-size: 1rem;
  line-height: 1.25rem;
  color: #313131;
  text-transform: capitalize;
  font-family: 'Nunito-Regular';
}
.events-profile-content .taps-content
{
  padding: 40px 0;
}
.events-profile-content .tap-content-data
{
  border: 1px solid #0080870F;
  border-radius: 20px;
  margin-top: 40px;
  padding: 24px 32px;
}
.events-profile-content .tap-content-data .text-part h4
{
  font-size: 1.125rem;
  line-height: 1.56rem;
  color:  #141522;
  text-transform: capitalize;
  margin-bottom: 20px;
  font-family: 'Nunito-Bold';
}
.events-profile-content .tap-content-data .text-part span
{
  display: block;
  margin-bottom: 18px;
  color:  #ED7923;
  font-size: 1rem;
  line-height: 1.375rem;
  text-transform: capitalize;
  font-family: 'Nunito-Bold';
}
.events-profile-content .tap-content-data .text-part p
{
  color:  #313131;
  font-size: 1rem;
  line-height: 1.375rem;
  margin-bottom: 7px;
  text-transform: capitalize;
  font-family: 'Nunito-Bold';
}
.events-profile-content .tap-content-data .img-content img{
  width: 100%;
  height: 172px;
  object-fit: cover;
  border-radius: 20px;
}
.events-profile-content hr
{
  margin: 20px 0;
  border-top: 1px solid rgba(0, 128, 135, 0.06);
}
.tap-content-data ul.social-link-profile
{
  margin-bottom: 0;
  justify-content: end !important;
}
</style>
